/**
 * Live feedback, computed from the public board and rack alone — the reference play never
 * reaches the client, and neither does the dictionary (CLAUDE.md §10, ADR 0040). It flags
 * one thing: tiles that cannot be played as they stand (off the line, floating, borrowed
 * from a rack that does not hold them). Whether the word exists is only known on submission.
 */
import type { Feedback } from "../types";
import { previewPlay } from "./board";
import { cellId, type ScrabbleDefinition, type ScrabbleProgress } from "./types";

export function localFeedback(
  definition: ScrabbleDefinition,
  progress: ScrabbleProgress,
): Feedback[] {
  const outcome = previewPlay(definition, progress);
  if (!outcome || outcome.legal) return [];
  return [
    {
      type: outcome.code,
      code: outcome.code,
      cells: outcome.cells.map(([r, c]) => cellId(r, c)),
      params: outcome.reason ? { reason: outcome.reason } : undefined,
    },
  ];
}
